module.exports = __webpack_public_path__ + "img/minibox-2.aa7ecfaa.png";